import React, { useContext, useState, useEffect } from 'react';
import useNetwork from '../useNetwork';
import { AppDataContext, VLink } from "./AppDataContext";
import { Helmet } from "react-helmet";

export function ResetPassword(props) {
    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

    
    const [isValid, setIsValid] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState('To change your password, you must type in your email, the new password, and confirm the new password.');
    const [formWasValidated, setFormWasValidated] = useState(false);

    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);

    const updateEmailValue = (evt) => { setEmail(evt.target.value) };
    const updatePasswordValue = (evt) => { setPassword(evt.target.value); };
    const updateConfirmPasswordValue = (evt) => { setConfirmPassword(evt.target.value); };


    useEffect(() => {
        const resetPassword = async () => {
            const url = 'api/site/resetpassword/' + props.match.params.resetCode;

            const response = await netRequest(url);


            if (response.data.isError) {
                setIsValid(false);
                setErrorMessage(response.data.message);
            } else {
                setIsValid(true);
            }


        };

        resetPassword();

    }, []);

    const onSubmitResetPasswordForm = async (event) => {
        event.preventDefault();
        await resetPassword();
    }

    const resetPassword = async () => {
        setFormWasValidated(true);
        setErrorMessage(null);
        setSuccessMessage(null);
        const url = 'api/site/resetpassword/' + props.match.params.resetCode;

        if (email.trim() != '' &&
            password.trim() != '' &&
            confirmPassword.trim() != '') {

            if (password.trim() !=
                confirmPassword.trim()) {
                setErrorMessage('Passwords do not match.');
                return;
            }

            setFormWasValidated(false);

            const postData = {
                email: email.trim(),
                password: password.trim()
                , confirmPassword: confirmPassword.trim()
            };

            const resp = await netRequest(url, postData);

            // clear the password
            setPassword("");
            setConfirmPassword("");

            if (resp.status != 200 || resp.data == null) {
                setErrorMessage("An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")");
            } else if (resp.data.isError) {
                setErrorMessage(resp.data.message);
            } else if (resp.data.status != "Success") {
                setErrorMessage("We were unable to reset your account, please contact support. (" + resp.data.status+ ")");
            } else {

                context.loggedIn(resp.data);
            }
        }
    }


    return (
        <main>
            <Helmet>
                <title>Reset Password</title>
            </Helmet>
            <section class=" py-5">
                <div class="container-fluid container-lg">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 offset-md-3">

                            <h4 class="auction-grid-header">
                                Reset Password
                                <div class="divider mt-2"></div>
                            </h4>
                        </div>
                        {isValid === false &&

                            <div class="col-sm-12 col-md-6 offset-md-3">
                                <p class="alert alert-danger mb-4">
                                    {errorMessage}
                                </p>
                            </div>

                        }

                        {context.isLoggedIn ===false && isValid === true &&
                            <>
                                <div class="col-sm-12 col-md-6 offset-md-3">
                                    {successMessage &&
                                        <p class="alert alert-success mb-4">
                                            {successMessage}
                                        </p>
                                    }
                                    {errorMessage &&
                                        <p class="alert alert-danger mb-4">
                                            {errorMessage}
                                        </p>
                                    }
                                </div>

                                <div class="col-sm-12 col-md-6 offset-md-3">
                                    <div class=" h-100 p-3 border-1 border-primary border-solid">
                                        <form className={"row g-3 needs-validation " + (formWasValidated == true ? "was-validated" : "")} onSubmit={onSubmitResetPasswordForm} >
                                            <div class="col-12">
                                                <label for="email" class="form-label w-100">Email</label>
                                                <input type="email" class="form-control" placeholder="Email" required id="email"
                                                    onChange={updateEmailValue}
                                                    value={email}
                                                    maxLength="100"
                                                    pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter your email.
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <label for="password" class="form-label w-100">New Password<span>*</span></label>
                                                <input type="password" class="form-control" id="password" required
                                                    onChange={evt => updatePasswordValue(evt)}
                                                    value={password}
                                                    placeholder="Password" maxLength="30"
                                                    minLength="8"
                                                    pattern="^(?=.*[A-Za-z])((?=.*\d)|(?=.*[@$!%*#?&]))[A-Za-z\d@$!%*#?&]{8,}$"
                                                />
                                                <div class="invalid-feedback">
                                                    Please enter the new password.
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <label for="email" class="form-label w-100">Confirm Password<span>*</span></label>
                                                <input type="password" class="form-control" id="password" required
                                                    onChange={evt => updateConfirmPasswordValue(evt)}
                                                    value={confirmPassword}
                                                    placeholder="Confirm Password" maxLength="30"
                                                    minLength="8"
                                                    pattern="^(?=.*[A-Za-z])((?=.*\d)|(?=.*[@$!%*#?&]))[A-Za-z\d@$!%*#?&]{8,}$"

                                                />
                                                <div class="invalid-feedback">
                                                    Please reenter the new password.
                                                </div>
                                            </div>

                                            <div class="col-12 small ">
                                                Password must have 8 or more characters and at least one number or special character.
                                            </div>
                                            <div class="col-12">
                                                <button type="submit" class="btn btn-secondary btn-fill w-100" onClick={() => { setFormWasValidated(true); }}>Reset</button>
                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </>
                        }

                        {context.isLoggedIn === true &&
                            <>


                                <div class="col-sm-12 col-md-6 offset-md-3">

                                    <p class="alert alert-success mb-4">
                                        Your password has been reset.
                                    </p>
                                    <VLink to="/" class="btn btn-secondary btn-fill w-100">
                                        Resume Treasure Hunting
                                    </VLink>

                                </div>
                            </>

                        }
                    </div>

                </div>
            </section>
        </main>
    )



}
